var React = require('react');

function TcInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9993 0.25L0.416016 8.75L6.08268 11.8383V20.3383L15.9993 25.75L25.916 20.3383V11.8383L28.7493 10.2942V20.0833H31.5827V8.75L15.9993 0.25ZM25.661 8.75L15.9993 14.02L6.33768 8.75L15.9993 3.48L25.661 8.75ZM23.0827 18.6525L15.9993 22.52L8.91602 18.6525V13.3825L15.9993 17.25L23.0827 13.3825V18.6525Z","fill":"#0E1FC1"}));
}

TcInline.defaultProps = {"width":"32","height":"26","viewBox":"0 0 32 26","fill":"none"};

module.exports = TcInline;

TcInline.default = TcInline;
